import ItemType from "../../../../../enums/itemType.enum";
import "./ItemCard.scss";

interface IItemCardProps {
  classname: string;
  amount?: number;
  hideAmount?: boolean;
  itemType: ItemType;
  onClick?: () => void;
}

const ItemCard = (props: IItemCardProps) => {
  let icon = "fa-regular fa-circle-question";

  let cardClasses = `item-card${props.onClick ? ` clickable` : ``}`;

  switch (props.itemType) {
    case ItemType.Weapon:
      icon = "fa-solid fa-gun";
      break;
    case ItemType.Backpack:
      icon = "fa-solid fa-briefcase";
      break;
    case ItemType.Magazine:
      icon = "fa-solid fa-shield";
  }

  return (
    <div className={cardClasses} onClick={props.onClick}>
      <div className="item-icon">
        <i className={icon}></i>
      </div>
      {!props.hideAmount && (
        <div className="amount-badge">{props.amount ?? 1}</div>
      )}
      <div className="item-classname">{props.classname}</div>
    </div>
  );
};

export default ItemCard;
